import React from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Button,
    Card,
    CardContent,
    Container,
    FormControl,
    Grid,
    InputLabel,
    OutlinedInput,
    TextField,
    Typography
} from '@mui/material';

// third-party
import { PatternFormat } from 'react-number-format';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';
import { gridSpacing } from 'store/constant';

// assets
import mailImg from 'assets/images/landing/widget-mail.svg';

// select options
const currencies = [
    {
        value: '1',
        label: 'Below $1000'
    },
    {
        value: '2',
        label: '$1000 - $5000'
    },
    {
        value: '3',
        label: 'Not specified'
    }
];

const sizes = [
    {
        value: '1',
        label: '1 - 5'
    },
    {
        value: '2',
        label: '5 - 10'
    },
    {
        value: '3',
        label: '10+'
    }
];

// ===========================|| CONTACT CARD - FORMS ||=========================== //

const ContactCard = () => {
    const theme = useTheme();

    const [budget, setBudget] = React.useState(1);
    const handleChange = (event) => {
        setBudget(Number(event.target?.value));
    };

    const [size, setSize] = React.useState(1);
    const handleChange1 = (event) => {
        setSize(Number(event.target?.value));
    };

    return (
        <Container>
            <Grid container justifyContent="center" spacing={gridSpacing}>
                <Grid item sm={10} md={7} sx={{ mt: { md: 12.5, xs: 2.5 }, mb: { md: 12.5, xs: 2.5 } }}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h1"
                                color="white"
                                component="div"
                                sx={{
                                    fontSize: '3.5rem',
                                    fontWeight: 900,
                                    lineHeight: 1.4,
                                    [theme.breakpoints.down('md')]: { fontSize: '1.8125rem', marginTop: '80px' }
                                }}
                            >
                                Liên hệ
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant="h5"
                                component="div"
                                sx={{ fontWeight: 400, lineHeight: 1.4, [theme.breakpoints.up('md')]: { my: 0, mx: 0 }, zIndex: 1009 }}
                                color="white"
                            >
                                Hãy cho chúng tôi biết chúng tôi có thể giúp gì được cho bạn. Muốn được hỗ trợ nhanh chóng? Hãy dùng thử
                                chatbot YouTeach.AI trực tiếp đã lập chỉ mục tất cả nội dung của chúng tôi.
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ position: 'relative', display: { xs: 'none', lg: 'block' } }}>
                    <img
                        src={mailImg}
                        alt="Berry"
                        style={{
                            marginBottom: -0.625,
                            position: 'absolute',
                            bottom: -90,
                            right: -100,
                            width: 400,
                            maxWidth: '100%',
                            animation: '5s wings ease-in-out infinite'
                        }}
                    />
                </Grid>
                <Grid item xs={10} sx={{ mb: -37.5 }}>
                    <Card sx={{ mb: 6.25 }} elevation={4}>
                        <CardContent sx={{ p: 4 }}>
                            <Grid container spacing={gridSpacing}>
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <InputLabel>Họ và tên</InputLabel>
                                        <OutlinedInput type="text" label="Họ và tên" placeholder="Nhập Họ và tên của bạn" />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Địa chỉ Email</InputLabel>
                                        <OutlinedInput type="text" label="Địa chỉ Email" placeholder="Nhập Email của bạn" />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <PatternFormat
                                            format="+84 ### ### ####"
                                            mask="_"
                                            fullWidth
                                            customInput={TextField}
                                            label="Số điện thoại"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <InputLabel>Chủ đề</InputLabel>
                                        <OutlinedInput type="text" label="Chủ đề" placeholder="Nhập chủ đề" />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="outlined-multiline-static1"
                                            placeholder="Nội dung cần hỗ trợ"
                                            multiline
                                            fullWidth
                                            rows={4}
                                            defaultValue=""
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={gridSpacing}>
                                        <Grid item sm zeroMinWidth>
                                            <Typography align="left" variant="body2">
                                                Khi gửi thông tin, bạn đã đồng ý với
                                                <Typography variant="subtitle1" component={Link} to="#" color="primary" sx={{ mx: 0.5 }}>
                                                    chính sách bảo mật
                                                </Typography>
                                                và
                                                <Typography
                                                    variant="subtitle1"
                                                    component={Link}
                                                    to="#"
                                                    color="primary"
                                                    sx={{ ml: 0.5, mr: 0.5 }}
                                                >
                                                    chính sách Cookie
                                                </Typography>
                                                của chúng tôi
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <AnimateButton>
                                                <Button variant="contained" sx={{ backgroundColor: theme.palette.main.items }}>
                                                    Gửi
                                                </Button>
                                            </AnimateButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ContactCard;
